import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import AttachmentsComponent, {
  AttachmentRenderType,
} from "components/common/attachments/AttachmentComponent";
import { AttachmentDrawerType } from "enums/AttachmentDrawerType";
import { ATTACHMENT_PARENT_TYPE } from "enums/AttachmentParentType";
import { Stack } from "components/layout/reusableLayouts";

interface ContactAttachmentsCardProps {
  contactId: string;
}

/** Uploads and removals save as they happen, outside the page's Edit and Save. */
const ContactAttachmentsCard: React.FC<ContactAttachmentsCardProps> = ({
  contactId,
}) => {
  const { t } = useTranslation();

  return (
    <Card variant="outlined" sx={{ padding: "var(--space-6)" }}>
      <Stack gap="var(--space-5)">
        <Typography variant="h5">{t("Attachments")}</Typography>
        <AttachmentsComponent
          renderType={AttachmentRenderType.ACCORDION}
          drawerType={AttachmentDrawerType.ATTACHMENT}
          layout="grid"
          parentDetails={{
            parentId: contactId,
            parentType: ATTACHMENT_PARENT_TYPE.CONTACT,
          }}
        />
      </Stack>
    </Card>
  );
};

export default ContactAttachmentsCard;
